/**
 * RelatedHubsFooter — calm inline footer rail rendered at the bottom of
 * each understanding hub (A1 Roundabouts, A2 Junctions, A3 Road
 * positioning). Completes the discovery circuit so the three hubs feel
 * like one connected understanding system rather than three isolated
 * pages.
 *
 * B0 Step 4 — hub-linking pass. Doctrine: inline linking only, no
 * rebuild, no new visual system. Calm slate palette, no animation.
 */
import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";

const HUBS = [
  { path: "/roundabouts",     label: "Roundabouts"      },
  { path: "/junctions",       label: "Junctions"        },
  { path: "/road-positioning",label: "Road positioning" },
];

export default function RelatedHubsFooter({ currentPath }) {
  const others = HUBS.filter((h) => h.path !== currentPath);
  if (others.length === 0) return null;
  return (
    <section
      data-testid="related-hubs-footer"
      data-current-hub={currentPath}
      className="mt-8 pt-6 border-t border-slate-200 dark:border-slate-800"
    >
      <p className="text-[10px] uppercase tracking-widest font-bold text-slate-500 dark:text-slate-400 mb-2">
        Related understanding hubs
      </p>
      <div className="flex flex-wrap gap-x-4 gap-y-2">
        {others.map((h) => (
          <Link
            key={h.path}
            to={h.path}
            data-testid={`related-hub-link-${h.path.slice(1)}`}
            className="inline-flex items-center gap-1 text-sm font-medium text-slate-700 dark:text-slate-200 underline-offset-2 hover:underline"
          >
            <ExternalLink className="w-3.5 h-3.5 opacity-70" />
            {h.label}
          </Link>
        ))}
      </div>
      <p className="text-[11px] text-slate-500 dark:text-slate-400 mt-2">
        Three hubs, one connected journey.
      </p>
    </section>
  );
}
